import React, { useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../../store/configureStore';
import { dcrActionCreators } from '../../store/DCRStore';
import { helperActionCreators } from '../../store/HelperStore';
import { cmsActionCreators } from '../../store/CmsStore';
import { stateLoading } from '../../functions/stateLoading';
import Skeleton from 'react-loading-skeleton';


type TLogoutProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContactUs = (props: TLogoutProps) => {

    const cmsContactUsData = props.cmsData.fragments?.find((f: any) => f.name === "ContactUs");

    useEffect(() => {
        if (stateLoading(props.cmsData)) {
            props.fetchCmsData();
        }
    });

    return (
        <Row className="logout-container">
            <Col>
                <Row className="ml-1 mt-2 my-3 mr-1">
                    <Col className="tbl-info-wrap float-left col-12">
                        <h4>Contact Us</h4>
                    </Col>
                </Row>

                <Row className="ml-3 mx-1 my-2">
                    <Col>
                        {cmsContactUsData ? <span dangerouslySetInnerHTML={{ __html: cmsContactUsData.html }} /> : <Skeleton width="80%" />}
                    </Col>
                </Row>
            </Col>
        </Row>
    );

}

function mapStateToProps(state: AppState) {
    return {
        currentUser: state.dcr.currentuserInfo.user,
        helper: state.helper,
        cmsData: state.cms.contactUs
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...dcrActionCreators,
            ...helperActionCreators,
            fetchCmsData: cmsActionCreators.fetchContactUsCmsData
        }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactUs);